import { useDraggable } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { IconDispatcher } from "shared/Icons";
import styled from "styled-components/macro";

type DragItemProps = {
	id: string;
	children:  React.ReactNode;
	width?: number;
	handleStyle?: React.CSSProperties;
	disabled?: boolean;
	innerRef?: React.Ref<HTMLDivElement>;
	globalStyle?: React.CSSProperties;
};
const defaulthandleStyle: React.CSSProperties = {
	padding: "8px",
	cursor: "grab", // Indicates drag interaction
	backgroundColor: "#ffffff",
	borderRadius: "4px",
	marginRight: "8px",
};

function Drag({ id, innerRef, children, handleStyle = defaulthandleStyle, globalStyle, disabled = false,
	
}: DragItemProps) {

	const { attributes, listeners, setNodeRef, transform, transition ,isDragging} = useSortable({ id, disabled });

	const style: React.CSSProperties = {
		// width: width ? `${width}px` : "100%",
		transition,
		transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
		userSelect: "none",
		zIndex:  isDragging ? 1 : undefined
		
	};


	return (
		<Container ref={setNodeRef} style={{ ...style, ...globalStyle }}>
			{/* Drag Handle - Only this part will be draggable */}
			<div className="position-relative">
			{!disabled && (
				<Handle {...listeners} {...attributes} style={handleStyle}>
					<IconDispatcher type="DRAG" />
				</Handle>
			)}
		</div>
			{/* Item Content - Not Draggable */}
			<div ref={innerRef} style={{ flex: 1, height: "100%" }}>
				{children}
			</div>
		</Container >
	);
}

type DragContainerProps = {
	id: string;
	children:  (item: any) => React.ReactNode;
	width?: number;
	handleStyle?: React.CSSProperties;
	disabled?: boolean;
	innerRef?: React.Ref<HTMLDivElement>;
	globalStyle?: React.CSSProperties;
};
export function DragContainer({ id, innerRef, children, handleStyle = defaulthandleStyle, globalStyle, disabled = false,
	
}: DragContainerProps) {

	const { attributes, listeners, setNodeRef, transform, transition ,isDragging} = useSortable({ id, disabled });

	const style: React.CSSProperties = {
		// width: width ? `${width}px` : "100%",
		transition,
		transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
		userSelect: "none",
		zIndex:  isDragging ? 1 : undefined
		
	};
	const DragIcon = () => {
			return <div className="position-relative">
			{!disabled && (
				<Handle {...listeners} {...attributes} style={handleStyle}>
					<IconDispatcher type="DRAG" />
				</Handle>
			)}
		</div>
	}

	return (
		<Container ref={setNodeRef} style={{ ...style, ...globalStyle }}>
			<div ref={innerRef} style={{ flex: 1, height: "100%" }}>
				{children(DragIcon)}
			</div>
		</Container >
	);
}
const Handle = styled.div<any>`
	display:none;
	margin-left: 0px;
	color: #605F60;
  zoom: 1.3;

`
const Container = styled.div<any>`

	:hover ${Handle} {
		display: block;
	}

`
export default Drag;
